const images = {
  noImage: require("./no_image.jpg"),
  noAccountImage: require("./no_account_image.jpg"),
};

export default images;
